import { render, staticRenderFns } from "./ListOverflowScroll.vue?vue&type=template&id=61bab8dd&scoped=true&"
import script from "./ListOverflowScroll.vue?vue&type=script&lang=js&"
export * from "./ListOverflowScroll.vue?vue&type=script&lang=js&"
import style0 from "./ListOverflowScroll.vue?vue&type=style&index=0&id=61bab8dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bab8dd",
  null
  
)

export default component.exports